<!-- 声音博物馆 -->

<script setup></script>

<template>
  <div id="museum">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#museum {
  height: 100%;
}
</style>
